import { useFormik } from "formik";
import React, { useEffect } from "react";
import FormikInputGroup from "../../components/formik/FormikInputGroup";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import { useDispatch, useSelector } from "react-redux";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { getUsers, fetchUsers } from "../../app/reducers/Users/userSlice";
import { fetchGreyQualities } from "../../app/reducers/GreyQuality/greyQualitySlice";
import {
  fetchEmbroideryOrders,
  updateEmroideryOrder,
  reset,
  getEmbroideryPO,
} from "../../app/reducers/Embroidery/embroiderySlice";
import { useMemo } from "react";
import { useState } from "react";
import DangerButton from "../../components/infrastructure/Buttons/DangerButton";
import { toast } from "react-toastify";
import { generateOptions } from "../../utils/Utils";
import ImageComponent from "../../components/ImageComponent";

const inputStyle = {
  width: "100px",
  borderColor: "#e4e6fc",
  borderRadius: "7px",
};

const productStyle = {
  width: "70px",
  borderColor: "#e4e6fc",
  borderRadius: "7px",
};

const numberInputStyle = {
  width: "70px",
  borderColor: "#e4e6fc",
  borderRadius: "7px",
};

const ReceiveEmbroidery = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reset({}));
  }, []);

  useEffect(() => {
    dispatch(fetchUsers({ __t: "vendor" }));
  }, []);

  const { loading, users } = useSelector(getUsers);
  const { embroideryPO } = useSelector(getEmbroideryPO);
  const [manufacturer, setManufacturere] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const embroideryData = useMemo(
    () =>
      embroideryPO?.docs
        ? embroideryPO.docs.filter(
          (d) => d.status != "completed" && d.status != "settled"
        )
        : [],
    [embroideryPO]
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      manufacturer: manufacturer ? manufacturer : "",
      poData: embroideryData
        ? embroideryData.map((d) => {
          return {
            ...d,
            activate: false,
            receivedNew: 0,
            damaged: 0,
          };
        })
        : [],
    },
    onSubmit: async (values) => {
      formik.resetForm();
    },
  });
  useEffect(() => {
    formik.resetForm();
  }, []);

  const submitDetails = async (e, index) => {
    try {
      setIsSubmitting(true);
      e.preventDefault();
      let detail = formik.values.poData[index];
      let received = [
        {
          date: new Date(),
          receivedItem: detail.receivedNew,
          damagedItem: detail.damaged,
        },
      ];
      if (detail.receivedNew + detail.damaged > detail.remaining) {
        return toast.error("Remaining limit Exceeded");
      }
      let remaining = detail.remaining - (detail.receivedNew + detail.damaged);
      let data = {
        _id: detail._id,
        catalog: detail.catalog,
        location: detail.location,
        received: [...detail.received, ...received],
        remaining: remaining,
      };
      if (remaining == 0) {
        data["status"] = "completed";
      } else {
        data["status"] = "incomplete";
      }
      // return
      await dispatch(updateEmroideryOrder(data));
      await dispatch(
        fetchEmbroideryOrders({
          manufacturer: formik.values.manufacturer,
          populate: true,
          status: { $in: ["pending", "incomplete"] },
        })
      );
      setManufacturere(manufacturer);
      formik.setFieldValue("manufacturer", formik.values.manufacturer);
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Receive Embroidery Order</h1>
      <br></br>
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
        <FormikSelectGroup
          formik={formik}
          label="Manufacturer"
          name="manufacturer"
          onChange={async (data) => {
            await dispatch(
              fetchEmbroideryOrders({
                manufacturer: data.value,
                populate: true,
              })
            );
            setManufacturere(data.value);
            formik.setFieldValue("manufacturer", data.value);
          }}
          required
          options={generateOptions({
            array: users ? users.docs : [],
            valueField: "_id",
            labelField: "name",
          })}
        />
        {/* border-collapse border border-slate-1000 table-auto w-full divide-y divide-slate-400 */}
        <div className="relative overflow-x-auto">
          <table
            className="table-auto w-full border text-center"
            style={{ padding: "10px" }}
          >
            <thead className="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200 p-2">
              <th scope="col" style={{ padding: "15px" }}>
                SRNO
              </th>
              <th scope="col" style={{ width: "170px" }}>
                Photo
              </th>
              <th scope="col">Catalog</th>
              <th scope="col">Location</th>
              <th scope="col">product</th>
              <th scope="col">Ordered Total</th>
              <th scope="col">Ordered Remaining</th>
              <th scope="col">Received</th>
              <th scope="col">Damaged</th>
              <th scope="col">Action</th>
            </thead>
            {formik.values.poData &&
              formik.values.poData.length > 0 &&
              formik.values.poData.map((product, index) => (
                <>
                  <tbody className="text-sm divide-y divide-slate-200">
                    <td>{index + 1}.</td>
                    <td className="p-3">
                      <div
                        style={{
                          width: "170px",
                          height: "auto",
                          padding: "10px",
                        }}
                      >
                        {product?.productData?.image && (
                          <ImageComponent src={product?.productData?.image} />
                          // <img
                          //   src={product?.productData?.image}
                          //   alt="nothing"
                          // />
                        )}
                      </div>
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={product?.catalogData?.name}
                        name={`product.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={product?.locationData?.name}
                        name={`product.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={productStyle}
                        value={product?.productData.color}
                        name={`product.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={numberInputStyle}
                        value={product?.quantity}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        formik={formik}
                        value={formik.values.poData[index]?.remaining}
                        style={numberInputStyle}
                        name={`poData.${index}.remaining`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        min={0}
                        formik={formik}
                        style={{
                          width: "70px",
                          backgroundColor:
                            !formik.values.poData[index].activate &&
                            "#D8D8D880",
                          borderColor: "#e4e6fc",
                          borderRadius: "7px",
                        }}
                        max={
                          formik.values.poData[index].remaining -
                          formik.values.poData[index].damaged
                        }
                        disabled={!formik.values.poData[index].activate}
                        name={`poData.${index}.receivedNew`}
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        formik={formik}
                        min={0}
                        style={{
                          width: "70px",
                          backgroundColor:
                            !formik.values.poData[index].activate &&
                            "#D8D8D880",
                          borderColor: "#e4e6fc",
                          borderRadius: "7px",
                        }}
                        max={
                          formik.values.poData[index].remaining -
                          formik.values.poData[index].receivedNew
                        }
                        disabled={!formik.values.poData[index].activate}
                        name={`poData.${index}.damaged`}
                      />
                    </td>
                    <td className="p-3">
                      <div style={{ display: "flex", gap: "10px" }}>
                        {!formik.values.poData[index].activate && (
                          <PrimaryButton
                            onClick={() =>
                              formik.setFieldValue(
                                `poData.${index}.activate`,
                                true
                              )
                            }
                          >
                            Activate
                          </PrimaryButton>
                        )}
                        {formik.values.poData[index].activate && (
                          <>
                            <DangerButton
                              onClick={() =>
                                formik.setFieldValue(
                                  `poData.${index}.activate`,
                                  false
                                )
                              }
                            >
                              Deactivate
                            </DangerButton>
                            <PrimaryButton
                              disabled={isSubmitting}
                              onClick={(e) => submitDetails(e, index)}
                            >
                              Submit
                            </PrimaryButton>
                          </>
                        )}
                      </div>
                    </td>
                  </tbody>
                </>
              ))}
          </table>
        </div>
      </form>
    </div>
  );
};

export default ReceiveEmbroidery;
